import {APIService} from "../../common/APIService";
import {Vehicle} from "../../dto/Vehicle";

export class VehicleService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`vehicles`)
    return json.data.map(item => Vehicle.fromJson(item))
  }

  public async add(trackingId: string, licensePlate: string, assignedEmployeeId: string|null) {
    const json = await this.postJson<{data: object[]}>(`vehicles`, {
      tracking_id: trackingId,
      license_plate: licensePlate,
      assigned_employee_id: assignedEmployeeId,
    })
    return Vehicle.fromJson(json.data)
  }

  public async edit(vehicleId: string, trackingId: string, licensePlate: string, assignedEmployeeId: string|null) {
    const json = await this.putJson<{data: object[]}>(`vehicles/${vehicleId}`, {
      tracking_id: trackingId,
      license_plate: licensePlate,
      assigned_employee_id: assignedEmployeeId,
    })
    return Vehicle.fromJson(json.data)
  }

  public async delete(vehicleId: string) {
    await this.deleteJson(`vehicles/${vehicleId}`)
  }
}